"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dynamicBarcode = exports.findVariantOfProduct = exports.barcodeNotFound = void 0;
const products_1 = require("./products");
const registerOperation_1 = require("./../models/registerOperation");
/**
 * Create new entry in Register Operations for failed scan barcode
 * @param  {CountrSdk} sdk - Countr sdk obj
 * @param  {Cart} cart - Cart obj
 * @param  {string} ean - Barcode/QRcode failed to scan
 * @returns {Promise<RegisterOperation>} Returns a promise when resolved contain the Register operation that was created
 */
const barcodeNotFound = (sdk, cart, ean) => {
    const { store, device, currency } = cart;
    return sdk.registerOperations.create({
        store,
        device,
        currency,
        date: new Date(),
        action: registerOperation_1.RegisterOperationActions.SCAN_FAIL,
        note: `Barcode ${ean} failed to scan`
    });
};
exports.barcodeNotFound = barcodeNotFound;
/**
 * Given a product and a barcode, find the variant that this barcode belongs
 * @param  {Product} product - Product obj
 * @param  {string} ean - Scanned barcode
 * @returns {Variant | undefined} Returns the variant that barcodes belongs or undefined if doesn't find
 */
const findVariantOfProduct = (product, ean) => {
    const variant = product.variants.find((v) => {
        // Removing spaces from variant.ean because in indexedDB we already save it without spaces
        // and onScanJS also scan the barcode without spaces
        if (!!v.ean && v.ean.replace(/\s/g, '') === ean) {
            return true;
        }
        else if (!!v.ean) {
            const splitedComma = v.ean.split(',');
            const splitedDash = v.ean.split('-');
            return splitedComma.indexOf(ean) >= 0 || splitedDash.indexOf(ean) >= 0;
        }
        return false;
    });
    return variant;
};
exports.findVariantOfProduct = findVariantOfProduct;
/**
 * Find the scanneds barcode inside the product list
 * @param  {Product[]} products - List of products
 * @param  {string} ean - Scanned barcode
 * @returns {Product | null} If product found, return it with updated price
 */
const dynamicBarcode = (products, ean) => {
    const search = products.filter((product) => {
        return (product.variants.filter((variant) => {
            return (variant.ean &&
                variant.ean.length >= 5 &&
                ean.toLowerCase().indexOf((variant.ean || '').toLowerCase()) >= 0);
        }).length > 0);
    });
    return !!search && search.length ? (0, products_1.isDynamicBarcode)(search[0], ean) : null;
};
exports.dynamicBarcode = dynamicBarcode;
